import React from 'react';
import {
    makeStyles,
    withStyles,
    Table,
    Divider,
    AppBar,
    Toolbar,
    IconButton,
    Container,
    Grid,
    Paper,
    Dialog,
    Typography,
    TextareaAutosize,
    Box,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import {FormattedMessage, useIntl} from 'react-intl';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {getMuiTheme} from "../../UIComponent/CommonStyle";
import MUIDataTable from "mui-datatables";
import Backdrop from "@material-ui/core/Backdrop";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import LeaveForm from "../../LeaveApplication/component/Form";
import Balance from "../../LeaveApplication/component/Balance";
import MiniTable from "../../UIComponent/MiniTable";
import RecentLeave from "../../LeaveApplication/component/RecentLeave";
import { AntSwitch } from '../../UIComponent/AntSwitch';
import CompLeaveReqsCollection from '../../Function/CompLeaveReqs';
import customAxios from '../../API/customAxios';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { getColumnsForBalanceRecord, getBalanceRecordOptions } from './TableSetting';
import { setLocalStorageSettings } from '../../Function/globalFunction';
import { isDesktop } from "react-device-detect";

const useStyles = makeStyles((theme) => ({
    content: {
        fontSize: 12,
    },
    circularProgressbar: {
        maxWidth: 120
    },
    circularProgress: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(1),
    },
    depositContext: {
        flex: 1,
    },
    container: {
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(1),
    },
    desktopContainer: {
        maxWidth: '80%',
        margin: '0 auto',
    },
    header: {
        fontSize: 12,
        fontWeight: 600
    },
    descriptionCell: {
        minWidth: 480,
        wordWrap: 'break-word',
        borderBottom: 'none',
        padding: 0,
    },
    textArea: {
        width: '100%',
        padding: 0,
    },
    totalRemaining: {
        fontSize: 16,
        fontWeight: 600,
    },
    toggle: {
        fontSize: 15,
        fontWeight: 600,
    },
    flexCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: !isDesktop ? 'flex-end' : undefined,
        margin: !isDesktop ? '5px 0' : undefined,
    },
    headerContainer: {
        display: 'flex',
        justifyContent:'space-between',
        alignItems: 'center',
        marginBottom: 5,
    },
}));

export default function BalanceTable({ handleClose, open }) {
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const page = 'Comp Leave Reqs';
    const [balanceData, setBalanceData] = React.useState([]);
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [toggle, setToggle] = React.useState(false);
    const [sumOfRemaining, setSumOfRemaining] = React.useState(0);
    const [openBalance, setOpenBalance] = React.useState(true);
    const isShiftDuty = localStorage.getItem('staff_duty') === window.global.shiftDuty;

    React.useEffect(() => {
        customAxios.get('/get_my_comp_leave_balance' + `?showExpiredRecords=${toggle}`).then((res) => {
            setShowCompetent(true);
            const getCompLeaveBalance = res.data;
            const sum = calculateTotalRemaining(getCompLeaveBalance);
            setSumOfRemaining(sum);
            setBalanceData(
                CompLeaveReqsCollection(
                    getCompLeaveBalance,
                    intl,
                    'Balance'
                )
            );
        });
    }, [toggle]);

    const handleChangeToggle = () => setToggle(!toggle);

    const handleCloseBalance = () => {
        setLocalStorageSettings({
            'selectedIndex': 4,
            'isMyRequestOpen': 'true',
            'isApplicationOpen': 'false',
            'isLeaveApprovalOpen': 'false',
            'isHRAdminOpen': 'false'
        });
        history.push('/myCompleaveReqs');
        setOpenBalance(false);
    };

    function calculateTotalRemaining(data) {
        let totalRemaining = 0;
        data.forEach((row) => {
            totalRemaining += Number(row.remaining) || 0;
        });
        return totalRemaining;
    }

    const columns = getColumnsForBalanceRecord(balanceData, intl, page, null, null); 
    const options = getBalanceRecordOptions(intl, page);

    return (
        <React.Fragment>
            {showCompetent ?(
                    <Dialog fullScreen open={open || openBalance} onClose={handleClose}
                            PaperProps={{
                                style: {
                                    backgroundColor: '#f0f2f5',
                                    boxShadow: 'none',
                                },
                            }}
                    >
                        <AppBar position="static" style={{backgroundColor: '#232F3E', color: '#fff'}}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={handleClose || handleCloseBalance} aria-label="close">
                                    <CloseIcon/>
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <main className={classes.content}>
                            <div className={classes.appBarSpacer}/>
                            <Container 
                                maxWidth={false}
                                className={`${classes.container} ${isDesktop ? classes.desktopContainer : ''}`}
                            >
                                <Grid container>
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Grid className={`${classes.root} ${isDesktop ? classes.headerContainer : ''}`}>
                                            <Typography
                                                className={classes.totalRemaining}
                                            >
                                                {isShiftDuty ? (
                                                    <FormattedMessage id='cash_out.pending_cash_out' />
                                                ) : (
                                                    <FormattedMessage id='comp_leave.total_remaining' />
                                                )}
                                                : {sumOfRemaining}
                                                {' '}<FormattedMessage id='comp_leave.hours' />
                                            </Typography>
                                            {!isShiftDuty && (
                                                <Box className={`${classes.flexCenter} ${classes.toggle}`}>
                                                    <FormattedMessage id='comp_leave.show_expired_record' />
                                                    <AntSwitch
                                                        checked={toggle}
                                                        onChange={handleChangeToggle}
                                                        name='show_expired_record'
                                                    />
                                                </Box>
                                            )}
                                        </Grid>
                                        <Paper className={classes.mainPaper}>
                                            <MuiThemeProvider theme={getMuiTheme()}>
                                                <MUIDataTable
                                                    title={intl.formatMessage({ id: 'comp_leave.endorsed_balance' })}
                                                    data={balanceData}
                                                    columns={columns}
                                                    options={options}
                                                />
                                            </MuiThemeProvider>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Container>
                        </main>
                    </Dialog>
                )
                :
                <div className={classes.circularProgress}>
                    <CircularProgress />
                </div>
            }
        </React.Fragment>
    );
}